module.exports = __webpack_public_path__ + "assets/573d25e3e7144ce7710fd5b30142855d.jpg";